import Http from "../../http/client";

export default async (id) => {
  await Http.delete('admin/trips/'+id+'/payment');
}
